export default {"src":"/_next/static/media/logo.30ab17bb.svg","height":37,"width":99,"blurWidth":0,"blurHeight":0};